const coverDogs = ['coverdog1', 'coverdog2', 'coverdog3', 'coverdog4', 'coverdog5', 'coverdog6', 'coverdog7', 'coverdog8']
const breederCoverdogs = ['breederCoverdog1', 'breederCoverdog2', 'breederCoverdog3', 'breederCoverdog4', 'breederCoverdog5', 'breederCoverdog6', 'breederCoverdog7', 'breederCoverdog8']

export { breederCoverdogs, coverDogs as default }
